import React from 'react';
import { CheckCircle2, Truck } from 'lucide-react';
export function EBTWICBanner() {
  return <div className="bg-gradient-to-r from-[#047857] to-[#059669] text-white py-2 md:py-3 overflow-hidden" data-id="element-11">
      <div className="md:hidden" data-id="element-12">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-6" data-id="element-13">
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-14">
            <CheckCircle2 className="w-3.5 h-3.5 text-[#86efac] flex-shrink-0" data-id="element-15" />
            <span className="text-xs font-bold" data-id="element-16">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-[#86efac] text-[#047857] px-2.5 py-1 rounded-full" data-id="element-17">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-18" />
            <span className="text-xs font-bold" data-id="element-19">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-20">
            <Truck className="w-3.5 h-3.5 text-[#86efac] flex-shrink-0" data-id="element-21" />
            <span className="text-xs font-semibold" data-id="element-22">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-full" data-id="element-23">
            <CheckCircle2 className="w-3.5 h-3.5 text-[#86efac] flex-shrink-0" data-id="element-24" />
            <span className="text-xs font-bold" data-id="element-25">EBT/SNAP Accepted</span>
          </div>
          <div className="flex items-center gap-1.5 bg-[#86efac] text-[#047857] px-2.5 py-1 rounded-full" data-id="element-26">
            <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" data-id="element-27" />
            <span className="text-xs font-bold" data-id="element-28">Free Delivery $35+</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-29">
            <Truck className="w-3.5 h-3.5 text-[#86efac] flex-shrink-0" data-id="element-30" />
            <span className="text-xs font-semibold" data-id="element-31">
              Uber Eats • DoorDash • Instacart • GrubHub
            </span>
          </div>
        </div>
      </div>
      <div className="hidden md:block max-w-7xl mx-auto px-6" data-id="element-32">
        <div className="flex items-center justify-center gap-6 lg:gap-8 flex-wrap" data-id="element-33">
          <div className="flex items-center gap-2" data-id="element-34">
            <CheckCircle2 className="w-5 h-5 text-[#86efac]" data-id="element-35" />
            <span className="text-sm font-semibold" data-id="element-36">WIC Approved</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-37">
            <CheckCircle2 className="w-5 h-5 text-[#86efac]" data-id="element-38" />
            <span className="text-sm font-semibold" data-id="element-39">EBT/SNAP</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-40">
            <CheckCircle2 className="w-5 h-5 text-[#86efac]" data-id="element-41" />
            <span className="text-sm font-semibold" data-id="element-42">USDA Partner</span>
          </div>
          <div className="flex items-center gap-2 bg-[#86efac] text-[#047857] px-3 py-1.5 rounded-full" data-id="element-43">
            <CheckCircle2 className="w-5 h-5" data-id="element-44" />
            <span className="text-sm font-bold" data-id="element-45">Free Delivery Over $35</span>
          </div>
          <div className="h-4 w-px bg-white/20" data-id="element-46" />
          <div className="flex items-center gap-3" data-id="element-47">
            <Truck className="w-5 h-5 text-[#86efac]" data-id="element-48" />
            <span className="text-sm font-semibold" data-id="element-49">Available on:</span>
            <div className="flex items-center gap-2 text-xs font-medium" data-id="element-50">
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-51">Uber Eats</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-52">DoorDash</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-53">Instacart</span>
              <span className="bg-white/10 px-2 py-1 rounded" data-id="element-54">GrubHub</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}